export enum CourtEventInfoActionTypes {
    LoadBlockedSlotDetails = '[CourtEventInfo] Load blocked slot details',
    ClearLoadedBlockedSlotDetails = '[CourtEventInfo] Clear loaded blocked slot details',
    GoToBlockedSlotDetails = '[CourtEventInfo] Go to blocked slot details',
    LoadCourtBookingDetails = '[CourtEventInfo] Load court booking details',
    ClearLoadedCourtBookingDetails = '[CourtEventInfo] Clear loaded court booking details',
    GoToCourtBookingDetails = '[CourtEventInfo] Go to court booking details',
    CheckInAllCourtBookingPlayers = '[CourtEventInfo] Check in all court booking players',
    NoShowAllCourtBookingPlayers = '[CourtEventInfo] No show all court booking players',
    CheckInCourtBookingPlayer = '[CourtEventInfo] Check in court booking player',
    LoadCourtClassDetails = '[CourtEventInfo] Load court class details',
    ClearLoadedCourtClassDetails = '[CourtEventInfo] Clear loaded court class details',
    GoToCourtClassDetails = '[CourtEventInfo] Go to court class details',
}

export class LoadBlockedSlotDetailsAction {
    static type = CourtEventInfoActionTypes.LoadBlockedSlotDetails;
    constructor(public blockedSlotId: string) {}
}

export class ClearLoadedBlockedSlotDetailsAction {
    static type = CourtEventInfoActionTypes.ClearLoadedBlockedSlotDetails;
}

export class GotToBlockedSlotDetailsAction {
    static type = CourtEventInfoActionTypes.GoToBlockedSlotDetails;
    constructor(public blockedSlotId: string) {}
}

export class LoadCourtBookingDetailsAction {
    static type = CourtEventInfoActionTypes.LoadCourtBookingDetails;
    constructor(public courtBookingId: string) {}
}

export class ClearLoadedCourtBookingDetailsAction {
    static type = CourtEventInfoActionTypes.ClearLoadedCourtBookingDetails;
}

export class GoToCourtBookingDetailsAction {
    static type = CourtEventInfoActionTypes.GoToCourtBookingDetails;
    constructor(public courtBookingId: string) {}
}

export class CheckInAllCourtBookingPlayersAction {
    static type = CourtEventInfoActionTypes.CheckInAllCourtBookingPlayers;
    constructor(public courtBookingId: string) {}
}

export class NoShowAllCourtBookingPlayersAction {
    static type = CourtEventInfoActionTypes.NoShowAllCourtBookingPlayers;
    constructor(public courtBookingId: string) {}
}
export class CheckInCourtBookingPlayerAction {
    static type = CourtEventInfoActionTypes.CheckInCourtBookingPlayer;
    constructor(public courtBookingId: string, public playerId: string) {}
}

export class LoadCourtClassDetailsAction {
    static type = CourtEventInfoActionTypes.LoadCourtClassDetails;
    constructor(public courtClassId: string) {}
}

export class ClearLoadedCourtClassDetailsAction {
    static type = CourtEventInfoActionTypes.ClearLoadedCourtClassDetails;
}

export class GoToCourtClassDetailsAction {
    static type = CourtEventInfoActionTypes.GoToCourtClassDetails;
    constructor(public courtBookingId: string) {}
}
